import store from '@/store'
export default [
  {
    path: '/report/payment-details',
    name: 'payment-detail',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/payment/payment-detail.vue')
  },
  {
    path: '/report/summary-cash-collections',
    name: 'summary-cash-collection',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/report/payment/summary-cash-collection.vue')
  },
  {
    path: '/report/cash-collection-by-cashiers',
    name: 'cash-collection-by-cashier',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/report/payment/cash-collection-by-cashier.vue')
  },
  {
    path: '/report/payment-by-services',
    name: 'payment-by-service',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/payment/payment-by-service.vue')
  },
  {
    path: '/report/monthly-payments',
    name: 'monthly-payment',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/payment/monthly-payment.vue')
  },
  {
    path: '/report/monthly-payment-by-fees',
    name: 'monthly-payment-by-fee',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/payment/monthly-payment-by-fee.vue')
  },
  {
    path: '/report/student-unpaids',
    name: 'student-unpaid',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/payment/student-unpaid.vue')
  },
  {
    path: '/report/void-invoices',
    name: 'void-invoice',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/payment/void-invoice.vue')
  },
  {
    path: '/report/annual-payments',
    name: 'annual-payment',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/payment/annual-payment.vue')
  },
  {
    path: '/report/overdue-payments',
    name: 'overdue-payment',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/payment/overdue-payment.vue')
  },
  {
    path: '/report/student-payments',
    name: 'student-payment',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/payment/student-payment.vue')
  },
  {
    path: '/report/discount-payments',
    name: 'discount-payment',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/payment/discount-payment.vue')
  },
  {
    path: '/report/yearly-payment-lists',
    name: 'yearly-payment-list',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/payment/yearly-payment-list.vue')
  },
  {
    path: '/report/sale-day-books',
    name: 'sale-day-book',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/payment/sale-day-book.vue')
  },
  {
    path: '/report/payment-trackings',
    name: 'payment-tracking',
    meta: { requiresAuth: true },
    component: () => import('@/pages/payment-tracking/index.vue')
  },
  {
    path: '/report/payment-trackings/invoice/:id',
    name: 'payment-tracking-invoice',
    meta: { requiresAuth: true },
    component: () => import('@/pages/payment-tracking/track-invoice.vue'),
    beforeEnter: async (to, from, next) => {
      await store.commit('invoice/SET_SHOW_DATA', {})
      await store.dispatch('invoice/find', to.params.id)
      next()
    }
  }
]
